// frontend/shared-ui/src/forms/StockFieldsGroup.jsx
import React from "react";
import QuickQuantityField from "./fields/QuickQuantityField";

/**
 * Renders Stock + Min Stock + Unit in one block.
 * Typically placed near the price fields in the product modal.
 */
export default function StockFieldsGroup({
  stock,
  minStock,
  unit,
  onStockChange,
  onMinStockChange,
  onUnitChange,
  lowStockThreshold,
  compact = false,
}) {
  const stockPresets = compact
    ? [1, 5, 10, 50]
    : [1, 5, 10, 25, 50, 100, 500, 1000];
  const minPresets = [0, 1, 3, 5, 10, 25];

  return (
    <div className="fh-stock-group">
      <div className="fh-stock-group__qty">
        <QuickQuantityField
          label="Quantity in Stock"
          value={stock}
          min={0}
          unit={unit}
          onValueChange={onStockChange}
          onUnitChange={onUnitChange}
          presets={stockPresets}
          required
          hint="How many units are physically available right now"
        />
      </div>

      <div className="fh-stock-group__min">
        <QuickQuantityField
          label="Minimum Stock (low-stock alert)"
          value={minStock}
          min={0}
          unit={unit}
          onValueChange={onMinStockChange}
          presets={minPresets}
          hint={
            lowStockThreshold != null
              ? `Global default: ${lowStockThreshold} ${unit}. Set per product to override.`
              : "When stock drops below this, the product is flagged as low-stock"
          }
        />
      </div>
    </div>
  );
}
